import { render, staticRenderFns } from "./UserToInstituteAssignment.vue?vue&type=template&id=1cb65cba"
import script from "./UserToInstituteAssignment.vue?vue&type=script&lang=ts"
export * from "./UserToInstituteAssignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports